import React from 'react';
import { Typography, Box } from '@mui/material';

const SFNoData = ({
    title,
    description,
    headingComponent
}) => {
    return (
        <Box mt={3} px={2} textAlign="center" style={{ maxWidth: '100%' }}>
            <Typography component={headingComponent} variant="h5" style={{ color: '#bb0000', fontWeight: 500, wordBreak: 'break-word', whiteSpace: 'normal' }} gutterBottom>
                {title}
            </Typography>
            <Typography variant="subtitle1">
                {description}
            </Typography>
        </Box>
    );
}

export default SFNoData;
